import React, { Component } from "react"
import PropTypes from "prop-types"

export default class DrilldownList extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  static defaultProps = {
    children: "",
    className: "",
  }

  render() {
    return (
      <ul {...this.props} className={"common-drilldown-list " + this.props.className}>
        {this.props.children}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/DrilldownList.js